"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Modal = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _isString = _interopRequireDefault(require("lodash/fp/isString"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _useOnKeyboardConfirm = _interopRequireDefault(require("@active/react-utils/eventHandler/useOnKeyboardConfirm"));
var _getActiveElement = _interopRequireDefault(require("@active/react-utils/dom/getActiveElement"));
var _ModalHeader = _interopRequireDefault(require("../ModalHeader"));
var _ActiveUIContext = require("../ActiveUIContext");
var _useModal2 = _interopRequireDefault(require("./useModal"));
var _excluded = ["className", "style", "title", "shown", "size", "onClose", "autoFocusClose", "finalFocusRef", "fullScreen", "fullScreenSm", "children", "customizeHeader", "rootElement", "zIndex"];
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var contentHasFocus = function contentHasFocus(root) {
  return (0, _getActiveElement["default"])() === root || root && root.contains((0, _getActiveElement["default"])());
};
var focusClose = function focusClose(root, closeIcon) {
  if (!contentHasFocus(root) && closeIcon) {
    closeIcon.focus();
  }
};
var ModalPresenter = function ModalPresenter(props) {
  var className = props.className,
    style = props.style,
    title = props.title,
    _props$shown = props.shown,
    shown = _props$shown === void 0 ? false : _props$shown,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? _noop["default"] : _props$onClose,
    _props$autoFocusClose = props.autoFocusClose,
    autoFocusClose = _props$autoFocusClose === void 0 ? false : _props$autoFocusClose,
    finalFocusRef = props.finalFocusRef,
    _props$fullScreen = props.fullScreen,
    fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
    _props$fullScreenSm = props.fullScreenSm,
    fullScreenSm = _props$fullScreenSm === void 0 ? false : _props$fullScreenSm,
    children = props.children,
    customizeHeader = props.customizeHeader,
    rootElement = props.rootElement,
    zIndex = props.zIndex,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var handleCloseIconKeydown = (0, _useOnKeyboardConfirm["default"])(onClose, [onClose]);
  var rootRef = (0, _react.useRef)(null);
  var closeRef = (0, _react.useRef)(null);
  var presentationRef = (0, _react.useRef)(null);
  var classes = (0, _classnames2["default"])((0, _defineProperty2["default"])({
    modal: true,
    'layer-modal': true,
    'modal-fullscreen-sm': fullScreenSm
  }, "modal-fullscreen".concat((0, _isString["default"])(fullScreen) ? "-".concat(fullScreen) : ''), fullScreen), "modal-".concat(size), className, zIndex);
  var maskClasses = (0, _classnames2["default"])({
    mask: true,
    'fade-in': true,
    'layer-modal': true
  }, zIndex);
  var _useModal = (0, _useModal2["default"])({
      shown: shown,
      onClose: onClose,
      finalFocusRef: finalFocusRef,
      rootRef: rootRef
    }),
    handleKeydown = _useModal.handleKeydown;
  (0, _react.useEffect)(function setCurrentFocus() {
    if (shown) {
      if (autoFocusClose && closeRef) {
        focusClose(rootRef.current, closeRef.current);
      } else {
        var _presentationRef$curr;
        (_presentationRef$curr = presentationRef.current) === null || _presentationRef$curr === void 0 || _presentationRef$curr.focus();
      }
    }
  }, [shown, autoFocusClose, presentationRef, rootRef, closeRef]);
  if (!shown) return null;
  return /*#__PURE__*/_reactDom["default"].createPortal(/*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    ref: rootRef,
    className: "modal-root",
    "data-testid": "modal-root"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: maskClasses
  }), /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: -1,
    ref: presentationRef,
    className: classes,
    style: style,
    onKeyDown: handleKeydown,
    "aria-modal": "true",
    "aria-label": title,
    "aria-describedby": "dialog_body",
    role: "dialog"
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "modal-content fade-in"
  }, !customizeHeader && /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], {
    ref: closeRef,
    title: title,
    onClose: onClose,
    onCloseKeyDown: handleCloseIconKeydown
  }), children))), rootElement);
};
var Modal = exports.Modal = (0, _ActiveUIContext.withRootElement)(ModalPresenter);
var _default = exports["default"] = Modal;